export default __webpack_public_path__ + "static/media/Wordpress_Ecommerce_MayAmor_Hair_Collection.f4299145.png";